'use client';

import { useMemo, useState } from 'react';
import CalculatorInputs from './CalculatorInputs';
import ResultsDisplay from './ResultsDisplay';
import { calculateProfitMargin } from './calculations';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  translations: ToolsTranslations['profitMargin'];
}

type ProfitMarginValues = {
  revenue: number;
  profit: number;
};

export default function ProfitMarginCalculator({ translations }: Props) {
  const [values, setValues] = useState<ProfitMarginValues>({
    revenue: 50000000,
    profit: 10000000,
  });

  const handleValuesChange = (field: keyof ProfitMarginValues, value: number) => {
    setValues(prev => ({ ...prev, [field]: value }));
  };

  const result = useMemo(() => calculateProfitMargin({ revenue: values.revenue, profit: values.profit }, translations), [values.revenue, values.profit, translations]);

  return (
    <section id="profit-margin-calculator" className="w-full my-12 tools">
      <div className="rounded-xl border border-gray-200 shadow-sm bg-white">
        <div className="p-6 border-b border-gray-100">
          <div>
            <h2 className="text-xl font-semibold text-blue-900">{translations.title}</h2>
            <p className="text-sm text-gray-600 mt-1">{translations.subtitle}</p>
          </div>
        </div>
        <div className="p-6 grid grid-cols-1 lg:grid-cols-2 gap-8">
          <CalculatorInputs values={values} onValuesChange={handleValuesChange} translations={translations} />
          <ResultsDisplay result={result} translations={translations} />
        </div>
      </div>
    </section>
  );
}


